module.exports = __webpack_public_path__ + "static/media/creature-arm-left.d23f90cc.svg";